import React, { Fragment } from 'react';
import { ComponentVerticalSpacing, ComponentWrapper, Pagination, BlogPost } from 'day8-react/build/new-components';
import { WpPageType } from '../../globalTypes';

type BlogPageWrapperType = {
  posts: WpPageType[]
  category?: number
  pagesCount?: number
  page?: number
  heading: string
  subheading: string
  handlePageChange?: (x: number) => Promise<void>
}

const BlogPageWrapper = ({ posts, category, pagesCount = 0, page, handlePageChange, heading, subheading }: BlogPageWrapperType) => (
  <Fragment>
    <ComponentVerticalSpacing>
      <ComponentWrapper className="text-center">
        <span className="d8-u-color-primary d8-u-ls-sm d8-u-text-bold">{subheading}</span>
        <h1 className="text-xl">{heading}</h1>
      </ComponentWrapper>
    </ComponentVerticalSpacing>
    <ComponentVerticalSpacing>
      <ComponentWrapper>
        <div className="d8-l-auto-grid">{posts?.length && posts.map(post => <BlogPost key={post.id} post={post} />)}</div>
      </ComponentWrapper>
    </ComponentVerticalSpacing>
    <ComponentVerticalSpacing>
      <ComponentWrapper>
        {!category && page && (pagesCount > 1) && (
          <Pagination pagesCount={pagesCount || 1} page={page} handlePageChange={handlePageChange} />
        )}
      </ComponentWrapper>
    </ComponentVerticalSpacing>
  </Fragment>
);

export default BlogPageWrapper;